<template>
  <div id="anchorMenu" class="anchor-menu show-for-large" data-test-component="anchorMenu">
    <div class="magellan">
      <div class="container">
        <nav class="row columns">
          <ul class="horizontal menu">
            <li v-for="(option, index) in options" :key="index">
              <a
                :href="link(option.AnchorPage, option.AnchorId)"
                :data-clicklabel="option.Label"
                data-clickcategory="minside"
                data-clickaction="click-header"
              >
                {{ option.Label }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'AnchorMenu',
  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      hash: window.location.hash,
      activeClass: 'active',
      target: null
    };
  },
  computed: {
    $element() {
      return $('.magellan ul li a');
    },
    searchBarVisible() {
      return this.$store.state.search.barShown;
    }
  },
  created() {
    if (window.location.hash.length === 0) {
      return;
    }

    this.target = window.location.hash;
  },
  mounted() {
    this.resetScroll();
    this.setActiveClass();
    this.scrollOnClick();
  },
  methods: {
    link(page, anchor) {
      return page.concat(anchor);
    },
    resetScroll() {
      // https://stackoverflow.com/a/13349759
      if (this.hash) {
        window.scrollTo(0, 0);

        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 1);
      }
    },
    setActiveClass() {
      const anchorMenu = this;

      window.addEventListener(
        'scroll',
        Utility.throttle(() => {
          this.$element.each(function () {
            const link = $(this);
            const section = $(this.hash);
            const offset = section.offset();
            const height = section.height();
            const sectionScrollTop = $(document).scrollTop() + 200;

            if (!offset) {
              return;
            }

            if (offset.top < sectionScrollTop) {
              link.addClass(anchorMenu.activeClass);

              if (offset.top + height < sectionScrollTop) {
                link.removeClass(anchorMenu.activeClass);
              }
            }

            if (offset.top > sectionScrollTop) {
              link.removeClass(anchorMenu.activeClass);
            }
          });
        })
      );
    },
    scrollOnClick() {
      this.$element.on('click', (event) => {
        const id = event.target.hash;

        if (id.length < 1) {
          return;
        }

        Utility.scrollToElem($(id), Utility.getScrollOffset(false));
        window.location.hash = `${id}`;
      });
    }
  }
};
</script>
